<script setup>
import $ from "jquery";
import BpmnModeler from "bpmn-js/lib/Modeler";
import { highLine } from "@/api/needDealt";
import { getNodeInfo } from "@/api//bpmnApi";
import { nextTick, ref, watch } from "vue";

const props = defineProps({
  xmlStr: {
    type: String,
    default: "",
  },
  instanceId: {
    type: [Number, String],
    default: null,
  },
});

// 缩放比例
const zoom = ref(1);

const bpmnModeler = ref(null);

const processView = ref(null);

const initBpmn = async () => {
  // const canvas = window.appDocument.querySelector("processView");
  bpmnModeler.value = new BpmnModeler({
    container: processView.value,
    additionalModules: [
      {
        paletteProvider: ["value", ""], //禁用/清空左侧工具栏
        labelEditingProvider: ["value", ""], //禁用节点编辑
        contextPadProvider: ["value", ""], //禁用图形菜单
        bendpoints: ["value", {}], //禁用连线拖动
        zoomScroll: ["value", ""], //禁用滚动
        //moveCanvas:['value',''],//禁用拖动整个流程图
        move: ["value", ""], //禁用单个图形拖动
      },
    ],
  });

  try {
    const result = bpmnModeler.value.importXML(props.xmlStr);
    console.log("success!");
    // 让图能自适应屏幕
    const canvas = bpmnModeler.value.get("canvas");
    canvas.zoom("fit-viewport", "auto");

    highLine(props.instanceId).then((res) => {
      const finishedColor = {
        stroke: "green",
        fill: "rgb(152, 203, 152)",
      };

      const waitingToDoColor = {
        stroke: "rgb(250 149 0)",
        fill: "rgb(255 245 141)",
      };
      console.log(res);

      const highPointArr = res.data.highPoint;
      const highLineArr = res.data.highLine;
      const waitingToDoArr = res.data.waitingToDo;
      const iDoArr = res.data.iDo;

      const elementRegistry = bpmnModeler.value.get("elementRegistry");
      const modeling = bpmnModeler.value.get("modeling");

      for (var i = 0; i < highPointArr.length; i++) {
        modeling.setColor(
          [elementRegistry.get(highPointArr[i].split("#")[0])],
          finishedColor
        );
      }
      for (var k = 0; k < waitingToDoArr.length; k++) {
        modeling.setColor(
          [elementRegistry.get(waitingToDoArr[k].split("#")[0])],
          waitingToDoColor
        );
      }
    });

    const overlays = bpmnModeler.value.get("overlays");
    const arr = bpmnModeler.value.get("elementRegistry")._elements;
    Object.getOwnPropertyNames(arr).forEach((e) => {
      const item = arr[e].element;
      if (item && item.type == "bpmn:UserTask") {
        const o = item.businessObject;
        const taskId = o.id;
        const node = {};
        node.assignee = o.$attrs["camunda:assignee"];
        node.candidateGroups = o.$attrs["camunda:candidateGroups"];
        node.candidateUsers = o.$attrs["camunda:candidateUsers"];
        if (
          o.loopCharacteristics &&
          o.loopCharacteristics.$attrs["camunda:collection"]
        ) {
          node.assignee = null;
          node.collection = o.loopCharacteristics.$attrs["camunda:collection"];
        }

        getNodeInfo(node).then((res) => {
          overlays.add(taskId, "note", {
            position: {
              top: 0,
              right: -5,
            },
            html: `<div id="${taskId}_note" style="display: none; background-color: white;width: 200px;box-shadow: 2px 2px 3px 0px #ccc;border-radius: 5px;border: 1px solid #ccc;padding: 5px;font-size: 14px;">
                          <div style="text-align: center;font-size: 16px;border-bottom: 1px solid #ccc;">${
                            o.name
                          }</div>
                          <div style="display: ${
                            res.data.assignee == null ? "none" : "flex"
                          };">
                            <div style="width: 60px;flex: none;">代理人：</div><div>${
                              res.data.assignee
                            }</div>
                          </div>
                          <div style="display: ${
                            res.data.collection == null ? "none" : "flex"
                          };">
                            <div style="width: 60px;flex: none;">会签人：</div><div>${
                              res.data.collection
                            }</div>
                          </div>
                          <div style="display: ${
                            res.data.candidateGroups == null ? "none" : "flex"
                          };">
                            <div style="width: 60px;flex: none;">候选组：</div><div>${
                              res.data.candidateGroups
                            }</div>
                          </div>
                          <div style="display: ${
                            res.data.candidateUsers == null ? "none" : "flex"
                          };">
                            <div style="width: 60px;flex: none;">候选人：</div><div>${
                              res.data.candidateUsers
                            }</div>
                          </div>
                        </div>`,
          });
        });
      }
    });
    initEvent();
  } catch (err) {
    console.error(err.message, err.warning);
  }
};

const blowUp = () => {
  const canvas = bpmnModeler.value.get("canvas");
  if (zoom.value < 3.0) {
    zoom.value += 0.2;
  }
  canvas.zoom(zoom.value);
};

const narrow = () => {
  const canvas = bpmnModeler.value.get("canvas");
  if (zoom.value > 0.6) {
    zoom.value = zoom.value - 0.2;
  }
  canvas.zoom(zoom.value);
};

const revert = () => {
  const canvas = bpmnModeler.value.get("canvas");
  zoom.value = 1.0;
  canvas.zoom("fit-viewport", "auto");
};

const resetBpmn = () => {
  if (bpmnModeler.value == null) {
    initBpmn();
  } else {
    //revert()
  }
};

const initEvent = () => {
  const eventBus = bpmnModeler.value.get("eventBus"); // 需要使用eventBus
  const eventTypes = ["element.hover", "element.out"]; // 需要监听的事件集合
  // const modeling = viewer.get('modeling')
  var elementRegistry = bpmnModeler.value.get("elementRegistry");
  var overlays = bpmnModeler.value.get("overlays");
  eventTypes.forEach((eventType) => {
    eventBus.on(eventType, (e) => {
      //排除根节点元素，也就是画布
      var shape = e.element ? elementRegistry.get(e.element.id) : e.shape;
      if (e && shape.type == "bpmn:UserTask") {
        var o = shape.businessObject;
        var taskId = o.id;
        if ($("#" + taskId + "_note")[0]) {
          $("#" + taskId + "_note").toggle();
        }
      }
    });
  });
};

watch(
  () => props.xmlStr,
  (newVal) => {
    if (newVal) {
      nextTick(() => {
        initBpmn();
      });
    }
  }
);

defineExpose({
  resetBpmn,
});
</script>

<template>
  <div class="viewDiv">
    <div class="top">
      <div class="h-title">流程图</div>
      <el-button-group class="bpmnButton">
        <el-button
          type="info"
          plain
          icon="el-icon-plus"
          @click="blowUp()"
        ></el-button>
        <el-button
          type="info"
          plain
          icon="el-icon-minus"
          @click="narrow()"
        ></el-button>
        <el-button
          type="info"
          plain
          icon="Refresh"
          @click="revert()"
        ></el-button>
      </el-button-group>
    </div>
    <div>
      <div id="processView" ref="processView"></div>
    </div>
  </div>
</template>

<style scoped>
.viewDiv {
  width: 100%;
  background: #fff;
  margin-bottom: 10px;
  padding: 20px 20px;
  overflow: hidden;
}
.h-title {
  border-left: 5px solid #1a7bb9;
  font-size: 20px;
  font-weight: bold;
  padding-left: 10px;
  margin-bottom: 15px;
}
#processView {
  height: 400px;
}
.bpmnButton {
  position: absolute;
  top: 16px;
  right: 25px;
}
</style>
